module.exports = "<div :class=\"[buttons.length < 3 ? 'mui-dialog-confirm' : 'mui-dialog-general']\" v-show=show transition=mui-dialog-mask> <div class=mui-dialog-mask v-el:mask></div> <div class=mui-dialog v-show=show transition=mui-dialog> <div class=mui-dialog-hd> <strong class=mui-dialog-title>{{ head }}</strong> </div> <div class=mui-dialog-bd> {{{ content }}} <slot></slot> </div> <div class=mui-dialog-ft> <a v-for=\"button in buttons\" :class=\"['mui-btn-dialog'].concat(button.classes)\" @click=button.onClick>{{ button.name }}</a> </div> </div> </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialog/index.vue
 ** module id = 156
 ** module chunks = 0
 **/